<template>
  <el-form class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-flex tw-gap-x-6 tw-gap-y-3 tw-items-start">
    <i-form-item :label="$t('adm.audit.filter.by_user')">
      <el-select
        :model-value="filters.action_user"
        placeholder=""
        filterable
        clearable
        :filter-method="userGroupsFilterMethod"
        :visible-change="handleUserGroupsVisibleChange"
        @change="(payload) => updateFilter('action_user', payload)"
      >
        <el-option-group
          v-for="group in filteredUserGroups.filter(({ users }) => users.length)"
          :key="group.role_name"
          :label="$capitalize(group.role_name)"
        >
          <el-option
            v-for="user in group.users"
            :key="user.id"
            :label="user.fullname"
            :value="user.id"
          />
        </el-option-group>
      </el-select>
    </i-form-item>

    <i-form-item :label="$t('adm.audit.filter.action')">
      <el-select
        :model-value="filters.action_name"
        placeholder=""
        filterable
        clearable
        :filter-method="actionsFilterMethod"
        :visible-change="handleActionsVisibleChange"
        @change="(payload) => updateFilter('action_name', payload)"
      >
        <el-option
          v-for="user in filteredActions"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        />
      </el-select>
    </i-form-item>

    <i-form-item :label="$t('adm.audit.filter.severity')">
      <el-select
        :model-value="filters.severity"
        placeholder=""
        filterable
        clearable
        @change="(payload) => updateFilter('severity', payload)"
      >
        <el-option
          v-for="user in severities"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        />
      </el-select>
    </i-form-item>

    <div class="tw-flex tw-gap-3 tw-w-full">
      <i-form-item :label="$t('common.fields.date_from')">
        <el-date-picker
          v-model="filters.action_date_from"
          type="date"
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY HH:mm:ss"
          @change="(payload) => updateFilter('action_date_from', payload)"
        />
      </i-form-item>
      <i-form-item :label="$t('common.fields.date_until')">
        <el-date-picker
          v-model="filters.action_date_to"
          type="date"
          placeholder=""
          format="DD.MM.YYYY"
          value-format="DD.MM.YYYY HH:mm:ss"
          @change="(payload) => updateFilter('action_date_to', payload)"
        />
      </i-form-item>
    </div>
  </el-form>
</template>

<script>
import { actionsFilterMixin } from '@/mixins/actionsFilterMixin';
import { userGroupsFilterMixin } from '@/mixins/userGroupsFilterMixin';
import { mapState } from 'vuex';

export default {
  mixins: [actionsFilterMixin, userGroupsFilterMixin],
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.foreigners.logs.filters,
      userGroups: (state) => state.v2.admin.messaging.messagingUsers,
      actions: (state) => state.v2.shared.enums.foreigner_audit_events,
      severities: (state) => state.v2.shared.enums.audit_severities,
    }),
  },

  methods: {
    updateFilter(field, payload) {
      this.$store.commit('v2/admin/foreigners/logs/updateFilter', { field, payload });
    },
  },
};
</script>
